"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ListNavItem", {
  enumerable: true,
  get: function get() {
    return _ListNavItem.ListNavItem;
  }
});
Object.defineProperty(exports, "ListNavItemDefaultProps", {
  enumerable: true,
  get: function get() {
    return _ListNavItem.ListNavItemDefaultProps;
  }
});
exports.default = exports.ListNavDefaultProps = exports.ListNav = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ListNavItem = _interopRequireWildcard(require("./ListNavItem"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ListNav = function ListNav(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      selected = props.selected,
      icon = props.icon,
      NewProps = _objectWithoutProperties(props, ["children", "className", "disabled", "selected", "icon"]);

  var listNavClassName = (0, _classnames.default)('listnav-component', className); // Combine the properties passed to the parent with the child elements.
  // Processing react children is a little weird, see https://reactjs.org/docs/react-api.html#reactchildren for details.

  var countValidChildren = 0;

  var newChildren = _react.default.Children.map(children, function (child) {
    if (child.type === _ListNavItem.default) {
      countValidChildren += 1;
      var newFixedIcon;

      if (typeof child.props.icon !== 'undefined') {
        newFixedIcon = _react.default.cloneElement(child.props.icon, {
          fixedWidth: true
        });
      } else if (typeof icon !== 'undefined') {
        newFixedIcon = _react.default.cloneElement(icon, {
          fixedWidth: true
        });
      }

      return _react.default.cloneElement(child, {
        icon: newFixedIcon,
        disabled: disabled || child.props.disabled,
        selected: selected || child.props.selected
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }); // No children then output nothing.


  if (_react.default.Children.count(children) === 0 || countValidChildren === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: listNavClassName
  }, NewProps), newChildren);
};

exports.ListNav = ListNav;
ListNav.propTypes = {
  className: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.bool.isRequired,
  icon: _propTypes.default.element,
  children: _propTypes.default.node
};
var ListNavDefaultProps = {
  className: '',
  disabled: false,
  selected: false
};
exports.ListNavDefaultProps = ListNavDefaultProps;
ListNav.defaultProps = ListNavDefaultProps;
var _default = ListNav; // re-exports for ListNavItem

exports.default = _default;